import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from "../components/Navbar/navigation";
import Footer from '../components/Footer/Footer';
import NavItems from "../components/NavItems/NavItems";

const MainLayout = () => {
  return (
    <div className="App">
      <header>
        <Navbar />
        <NavItems />
      </header>

      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
